module.exports = __webpack_public_path__ + "img/electric_enabled.cff7effa.svg";